import Types from '../../../modules/types';

const {
  CONSTANTS: {
    StoreProductType,
    ProductKind,
  },
} = Types;

// const activityNotEdit = props => props && props.activity !== 'edit';
export const activityNotCreate = props => props && props.activity !== 'create';
export const activityNotEdit = props => props && props.activity !== 'edit';

export const productStoreInternal = props => (
  props.data?.storeData?.internal === true
);

export const productTypeNotMerchant = [
  'condition.testFieldValue',
  'type',
  '!==',
  StoreProductType.MERCHANT_PRODUCT,
];

export const productTypeNotReferral = [
  'condition.testFieldValue',
  'type',
  '!==',
  StoreProductType.REFERRAL_PRODUCT,
];

export const productTypeNotReseller = [
  'condition.testFieldValue',
  'type',
  '!==',
  StoreProductType.RESELLER_PRODUCT,
];

export const productTypeNotMerchantNorReseller = ['condition.and', [
  productTypeNotMerchant,
  productTypeNotReseller,
]];

export const productKindIsAbstract = [
  'condition.testFieldValue',
  'kind',
  kind => Types.PRODUCT_KIND_ABSTRACT.includes(kind),
  ProductKind.TANGIBLE,
];

export const productKindNotAbstract = [
  'condition.not',
  productKindIsAbstract,
];

export const productUnlockOnPurchaseNotEnabled = [
  'condition.testFieldValue',
  'unlockOnPurchase.enabled',
  '!==',
  true,
];

export const variationProductKindIsAbstract = (props) => {
  if (props.forms && props.forms.length) {
    return Types.PRODUCT_KIND_ABSTRACT.includes(
      props.forms[0].getFieldValue('kind')
    );
  }
  return false;
};
